import { Calculator, FileDown, Camera, Ruler, ShieldCheck } from "lucide-react";

const STEPS = [
  { icon: Calculator, title: "Calcula", text: "Una estimación inicial según el tipo de trabajo y la medición aproximada." },
  { icon: FileDown, title: "Descarga PDF", text: "Una estimación profesional con tu desglose y los datos de la empresa." },
  { icon: Camera, title: "Envía fotos", text: "Por WhatsApp para que podamos valorar mejor el estado real del trabajo." },
  { icon: Ruler, title: "Revisamos", text: "Medidas, materiales y condiciones reales en visita técnica si es necesario." },
  { icon: ShieldCheck, title: "Confirmamos", text: "El presupuesto definitivo tras visita técnica, claro y con garantía." },
];

export default function SistemaPS24() {
  return (
    <section className="bg-white border-y border-slate-200 scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#004B87] font-semibold mb-3">Nuestro método</div>
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">
            Sistema <span className="text-[#004B87]">PS24</span> de estimación orientativa
          </h2>
          <p className="text-slate-600 mt-3 text-base leading-relaxed">
            Calcula tu reforma, descarga una estimación en PDF, envíanos fotos por WhatsApp y confirmamos el presupuesto tras visita técnica.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {STEPS.map((s, i) => (
            <div
              key={i}
              data-testid={`ps24-step-${i + 1}`}
              className="relative p-5 rounded-xl border border-slate-200 bg-white hover:border-[#004B87]/40 hover:shadow-md transition-all"
            >
              <div className="absolute -top-3 -left-3 w-8 h-8 rounded-lg bg-[#004B87] text-white font-display font-bold grid place-items-center shadow-md text-sm">
                {i + 1}
              </div>
              <div className="w-10 h-10 rounded-lg bg-[#E6F0FA] text-[#004B87] grid place-items-center mb-3 mt-2">
                <s.icon className="w-5 h-5" />
              </div>
              <div className="font-display font-semibold text-slate-900 text-[15px] leading-tight">{s.title}</div>
              <div className="text-xs text-slate-500 mt-2 leading-snug">{s.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
